import { motion } from "framer-motion";
import { useEffect, useState } from "react";

const FramerTypewriter = ({ 
  texts = [], 
  speed = 0.05, 
  delay = 1,
  cursor = true,
  loop = true
}) => {
  const [index, setIndex] = useState(0);
  const [subIndex, setSubIndex] = useState(0);
  const [reverse, setReverse] = useState(false);
  const [blink, setBlink] = useState(true);

  // Typewriter effect
  useEffect(() => {
    if (texts.length === 0) return;

    if (subIndex === texts[index].length + 1 && !reverse) {
      setReverse(true);
      return;
    }

    if (subIndex === 0 && reverse) {
      setReverse(false);
      setIndex((prev) => (loop ? (prev + 1) % texts.length : Math.min(prev + 1, texts.length - 1)));
      return;
    }

    const timeout = setTimeout(() => {
      setSubIndex((prev) => prev + (reverse ? -1 : 1));
    }, speed * 1000);

    return () => clearTimeout(timeout);
  }, [subIndex, index, reverse, texts, speed, loop]);

  // Blinking cursor
  useEffect(() => {
    if (!cursor) return;
    
    const blinkTimeout = setTimeout(() => {
      setBlink((prev) => !prev);
    }, 500);

    return () => clearTimeout(blinkTimeout);
  }, [blink, cursor]);

  return (
    <motion.span
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay }}
    >
      {texts[index].substring(0, subIndex)}
      {cursor && (
        <motion.span
          animate={{ opacity: blink ? 1 : 0 }}
          transition={{ duration: 0.5 }}
          style={{ marginLeft: 2, color:"blue" }}
        >
          |
        </motion.span>
      )}
    </motion.span>
  );
};

export default FramerTypewriter;